var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { width: "1200px", margin: "0 auto" } }, [
    _c("div", { staticClass: "paper-detail" }, [
      _c("div", { staticClass: "paper-title" }, [
        _c("span", { staticClass: "paper-bg" }, [_vm._v("专利")]),
        _c("div", { staticClass: "paper-title-style" }, [
          _vm._v(_vm._s(_vm.patentData.title)),
        ]),
      ]),
      _c("div", {
        staticStyle: {
          width: "100%",
          "border-bottom": "1px dashed #e8eaee",
          "margin-top": "20px",
          "margin-bottom": "20px",
        },
      }),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { display: "flex", width: "50%" } }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            [
              _c("span", { staticClass: "textSpan" }, [_vm._v("发明人：")]),
              !_vm.patentData.authors || _vm.patentData.authors.length === 0
                ? _c("div", [_vm._v(" - ")])
                : _vm._l(
                    _vm.patentData.authors.length > 3 && !_vm.isAuthorsMore
                      ? _vm.patentData.authors.slice(0, 3)
                      : _vm.patentData.authors,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            display: "flex",
                            "margin-right": "11px",
                            "align-items": "center",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goPersonalDetails(item.scholarId)
                            },
                          },
                        },
                        [
                          _c("el-avatar", {
                            staticClass: "avatar",
                            attrs: { size: 18, src: item.avatarUrl },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "textContent",
                              staticStyle: { "margin-left": "6px" },
                            },
                            [_vm._v(" " + _vm._s(item.scholarName) + " ")]
                          ),
                        ],
                        1
                      )
                    }
                  ),
              _vm.patentData.authors &&
              _vm.patentData.authors.length > 3 &&
              !_vm.isAuthorsMore
                ? _c(
                    "span",
                    {
                      staticClass: "textSpan pointer",
                      staticStyle: { color: "rgb(46, 31, 136)" },
                      on: { click: _vm.authorsMore },
                    },
                    [_vm._v("更多>>")]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利类型："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(_vm._s(_vm.patentData.patentType || "-")),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [_vm._v("申请人：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(_vm._s(_vm.patentData.applicantName || "-")),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("申请时间："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.patentData.applicationDate
                    ? _vm.formatToDate(_vm.patentData.applicationDate)
                    : "-"
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利授权号："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(" " + _vm._s(_vm.patentData.authorizationNum || "-") + " "),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利分类号："),
          ]),
          _c(
            "div",
            {
              staticClass: "textContent",
              staticStyle: {
                "white-space": "pre-wrap",
                "word-break": "break-all",
                "word-wrap": "break-word",
              },
            },
            [_vm._v(" " + _vm._s(_vm.patentData.classCode || "-") + " ")]
          ),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利申请号："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.patentData.applicationNum == null
                    ? "-"
                    : _vm.patentData.applicationNum
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [_vm._v("公开号：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(" " + _vm._s(_vm.patentData.publicationNum || "-") + " "),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利国家代码："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " + _vm._s(_vm.patentData.applicationAreaCode || "-") + " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("申请人及区域代码："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " + _vm._s(_vm.patentData.applicationAreaCode || "-") + " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("优先权日："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.patentData.priorityDate
                    ? _vm.formatToDate(_vm.patentData.priorityDate)
                    : "-"
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("专利状态："),
          ]),
          _c(
            "div",
            { staticClass: "textContent", staticStyle: { color: "#00c27c" } },
            [_vm._v(" " + _vm._s(_vm.patentData.legalStatus || "-") + " ")]
          ),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [
            _vm._v("公开日期："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.patentData.publicationDate
                    ? _vm.formatToDate(_vm.patentData.publicationDate)
                    : "-"
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan noWrap" }, [_vm._v("页数：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(" " + _vm._s(_vm.patentData.pageCnt || "-") + " "),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticStyle: { "text-align": "start", "margin-top": "8px" } },
        [
          _c("span", { staticClass: "textSpan" }, [
            _vm._v("摘要："),
            _c("span", {
              staticClass: "textContent",
              domProps: { innerHTML: _vm._s(_vm.patentData.summary || "-") },
            }),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }